import {Component, Input, OnChanges} from '@angular/core';
import {Chart} from "chart.js";

export interface PieChartData {
  labels: string[],
  datasets: PieChartDataSet[],
}

export interface PieChartDataSet {
  label: string,
  data: number[],
  backgroundColor: string[],
  hoverOffset: number
}

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
  standalone: true,
})
export class PieChartComponent implements OnChanges {
  public chart: any;
  @Input() chartData: PieChartData

  ngOnChanges(): void {
    if (this.chart) {
      this.chart.destroy()
    }
    console.log('create new chart', this.chartData)
    this.chart = new Chart('reportChart', {
      type: 'doughnut',
      data: this.chartData
    })
  }
}
